





import Vue from "vue"

import { addLayer } from "../utils/MapUtils";

import { GeoJsonLayer } from '@deck.gl/layers';
import { MapboxLayer } from '@deck.gl/mapbox';
import { Feature, Polygon, Geometry, Properties } from '@turf/helpers';
import { Popup, LngLat, LngLatLike } from 'mapbox-gl';
import centroid from "@turf/centroid";
import { hexToArray, brandColor, trackColor } from '../utils/Utils';

export default Vue.extend({


	inject: ["$map"],

	data() {
		return {
			updates: 0,
		}
	},

	static() {
		return {
			// popup: undefined as Popup|undefined,
			// popupFeature: undefined as Feature|undefined,
			layer:undefined as MapboxLayer|undefined
		}
	},

	props: {
		polygons: {
			type: Array as () => Feature<Polygon>[],
			default: null,
		},

		progress: {
			type:Number,
		}
	},

	watch: {
		progress(newValue) {
			this.$static.layer.setProps({updateTriggers: {getFillColor:++this.updates}})
		}
	},

	
	
	methods: {
		initMap() {
			this.$static.layer = new MapboxLayer({
				type: GeoJsonLayer,
				_subLayerProps: {
					"polygons-fill": {
						getPolygonOffset: () => [0, 30000], // draw above billboarded MapTrack
					},
					"polygons-stroke": {
						getPolygonOffset: () => [0, 10000], // draw below billboarded MapTrack
					}
				},
				id: "polygons",
				data: this.polygons,
				pickable: true,
				onHover: this.onHover,
				lineWidthUnits: "pixels",
				getLineWidth: 1,
				stroked: true,
				filled: true,
				extruded: false,
				depthTest: false,
				getElevation: 0,
				getLineColor: [60,60,60,200], 
				getFillColor: point => {
					return point.properties.progress <= this.progress ? hexToArray(trackColor(), .4) : [100,100,100,100];
				},
			});

			addLayer(this.$map, this.$static.layer);
		},

		onHover(info, event) {

			// if(info.picked){
			// 	const feature = info.object;
			// 	if(feature != this.$static.popupFeature) {
			// 		this.removePopup();
			// 		this.createPopup(feature);

			// 	}
			// } else if(this.$static.popup) {
			// 	this.removePopup();
			// }
			return true;
		},

		// createPopup(feature:Feature<Polygon, Properties>):void {
		// 	const center = centroid(feature)
			
		// 	this.$static.popup = new Popup({
		// 		closeButton: false,
		// 		closeOnClick: false,
		// 	})
		// 	.setText(feature.properties!.desc)
		// 	.setLngLat(this.getTop(feature))
		// 	.addTo(this.$map)
		// 	this.$static.popupFeature = feature;

		// },

		// removePopup() {
		// 	if(this.$static.popup) {
		// 		this.$static.popup.remove();
		// 		this.$static.popup = undefined;
		// 		this.$static.popupFeature = undefined;
		// 	}
		// },

		// getTop(poly:Feature<Polygon>):LngLatLike {
		// 	const coords = poly.geometry!.coordinates[0];
			
		// 	const max = coords.reduce((res, coords) => {
		// 		return coords[1] > res[1] ? coords : res;
		// 	}, [0,0])

		// 	return max as [number, number];

		// }
	},


	mounted() {
		this.initMap();
	},


})

